<template>
  <div id="nav-side">
    <div style="margin: 8px 6px 0 6px">
      <el-input
        placeholder="Keyword search"
        type="text"
        ref="searchInput"
        v-model="searchText"
        @clear="clearKeyword"
        @keyup.enter.native="handleSearch">
      </el-input>
    </div>
    <el-menu default-active="1" class="el-menu-vertical-demo nav-menu" theme="dark" style="width:100%;" :collapse="isCollapse" router>
      <!-- Home -->
      <el-submenu index="0" class="nav-side" id="dashboard">
        <template slot="title">
          <a href="/home" onclick="javascript:return false;">
            <router-link :to="{ name: 'Home' }">
              Home
            </router-link>
          </a>
        </template>
      </el-submenu>

      <!-- Payroll -->
      <el-submenu index="1" class="nav-side" id="payrollmenu" v-if="payrollEnabled">
        <template slot="title">
          <a href="/payroll/reports" onclick="javascript:return false;">
            <router-link :to="{ name: 'PrReport' }">
              ProPay
            </router-link>
          </a>
        </template>
        <el-menu-item-group>
          <span slot="title">Please select a function ...</span>
          <el-menu-item index="/payroll/reports">
            Payroll Reporting
          </el-menu-item>
          <el-menu-item index="/payroll/clientexport">
            Payroll Client Export
          </el-menu-item>
          <el-menu-item index="/payroll/prcheckregister">
            Payroll Check Register
          </el-menu-item>
          <el-menu-item index="/payroll/status">
            Payroll Status
          </el-menu-item>
          <el-menu-item index="/payroll/unionexport">
            Payroll Union Export
          </el-menu-item>
          <el-menu-item index="/payroll/ddexport">
            Payroll Direct Deposit Export
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>

      <!-- Quick Add -->
      <el-submenu index="2" class="nav-side" id="quickadd" v-if="checkIfUserHasAnyOfThePermissions(quickAddPermissions)">
        <template slot="title">Quick Add</template>
        <el-menu-item-group v-if="checkIfUserHasAnyOfThePermissions(quickAddPermissions)">
          <span slot="title">Create a New ...</span>
          <el-menu-item index="" v-if="checkIfUserHasRequiredPermissions(['entry.add_purchaseorder'])">
            <a href="/pos/new" target="_blank">
              <span>Purchase Order</span>
            </a>
          </el-menu-item>
          <el-menu-item index="" v-if="checkIfUserHasRequiredPermissions(['entry.add_accountspayable'])">
            <a href="/aps/new" target="_blank">
              <span>A/P Invoice</span>
            </a>
          </el-menu-item>
          <el-menu-item index="" v-if="checkIfUserHasRequiredPermissions(['entry.add_pettycash'])">
            <a href="/pettycash/new" target="_blank">
              <span>Petty Cash Envelope</span>
            </a>
          </el-menu-item>
          <el-menu-item index="" v-if="checkIfUserHasRequiredPermissions(['entry.add_journalentry'])">
            <a href="/jes/new" target="_blank">
              <span>Journal Entry</span>
            </a>
          </el-menu-item>
          <el-menu-item index="" v-if="checkIfUserHasRequiredPermissions(['system.view_vendor', 'system.add_vendor'])" @click="openComponentCreateModal('changeModalVisibility', 'customerVendorForm', 'vendor')">
            <span>Vendor</span>
          </el-menu-item>
          <el-menu-item index="" v-if="checkIfUserHasRequiredPermissions(['entry.view_payment'])">
            <a href="/programs/checks" target="_blank">
              Check Run
            </a>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>

      <!-- Proscan -->
      <el-submenu index="3" class="nav-side" id="proscan" v-if="checkIfUserHasAnyOfThePermissions(proscanPermissions)">
        <template slot="title">
          <a href="/proscan" @click="clearFilters">
            <router-link :to="{ name: 'Proscan' }">
              Proscan
            </router-link>
          </a>
          <div class="newTag">NEW</div>
        </template>
        <el-menu-item-group>
          <span slot="title">Proscan</span>
          <el-menu-item index="/proscan">
            <a href="/proscan" @click="clearFilters">
              <router-link :to="{ name: 'Proscan' }">View All</router-link>
            </a>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>

      <!-- Accounts Payable -->
      <el-submenu index="4" class="nav-side" id="accountspayable" v-if="checkIfUserHasRequiredPermissions(['entry.view_accountspayable'])">
        <template slot="title">
          <a href="/aps" @click="clearFilters">
            <router-link :to="{ name: 'APs' }">
              Accounts Payable
            </router-link>
          </a>
        </template>
        <el-menu-item-group>
          <span slot="title">Accounts Payable</span>
          <el-menu-item index="/aps">
            <a href="/aps" @click="clearFilters">
              <router-link :to="{ name: 'APs' }">View All A/Ps</router-link>
            </a>
          </el-menu-item>
          <el-menu-item index="/reports/apagingreport" v-if="checkIfUserHasRequiredPermissions(['auth.view_ap_aging_report'])">
            <a href="/reports/apagingreport" onclick="javascript:return false;">
              Aging Report
            </a>
          </el-menu-item>
          <el-menu-item index="/programs/posting?type=Aps" v-if="checkIfUserHasRequiredPermissions(['auth.post_transactions'])">
            <a href="/programs/posting?type=Aps" onclick="javascript:return false;">
              Audit/Post
            </a>
          </el-menu-item>
          <el-menu-item index="/pos/new" v-if="checkIfUserHasRequiredPermissions(['entry.add_purchaseorder'])">
            <a href="/pos/new" onclick="javascript:return false;">
              <span>
                Add Purchase Order
              </span>
            </a>
          </el-menu-item>
          <el-menu-item index="/aps/new" v-if="checkIfUserHasRequiredPermissions(['entry.add_accountspayable'])">
            <a href="/aps/new" onclick="javascript:return false;">
              <span>
                Add Invoice
              </span>
            </a>
          </el-menu-item>
          <el-submenu index="" v-if="checkIfUserHasAnyOfThePermissions(['system.view_vendor', 'system.add_vendor'])">
            <span slot="title">Vendors</span>
            <el-menu-item index="/vendors" v-if="checkIfUserHasRequiredPermissions(['system.view_vendor'])">
              <a href="/vendors" onclick="javascript:return false;">
                View all
              </a>
            </el-menu-item>
            <el-menu-item
              index=""
              v-if="checkIfUserHasRequiredPermissions(['system.add_vendor'])"
              @click="openComponentCreateModal('changeModalVisibility', 'customerVendorForm', 'vendor')">
              <span>New Vendor</span>
            </el-menu-item>
          </el-submenu>
        </el-menu-item-group>
      </el-submenu>

      <!-- Payments -->
      <el-submenu index="5" class="nav-side" id="payments" v-if="checkIfUserHasAnyOfThePermissions(['entry.view_payment', 'entry.pospay_payment'])">
        <template slot="title" v-if="checkIfUserHasRequiredPermissions(['entry.view_payment'])">
          <a href="/payments" @click="clearFilters">
            <router-link :to="{ name: 'Payments' }">
              Payments
            </router-link>
          </a>
        </template>
        <el-menu-item-group v-if="checkIfUserHasAnyOfThePermissions(['entry.view_payment', 'entry.pospay_payment'])">
          <span slot="title">Payments</span>
          <el-menu-item index="/programs/payments">
            <a href="/programs/payments" @click="clearFilters">
              Payment Processing
            </a>
          </el-menu-item>
          <el-menu-item index="/payments" v-if="checkIfUserHasRequiredPermissions(['entry.view_payment'])">
            <a href="/payments" @click="clearFilters">
              View All Payments
            </a>
          </el-menu-item>
          <el-menu-item index="/reports/paymentregister" v-if="checkIfUserHasRequiredPermissions(['auth.view_payment'])">
            <a href="/reports/paymentregister" @click="clearFilters">
              <span>
                Payment Register
              </span>
            </a>
          </el-menu-item>
          <el-menu-item index="/programs/checks" v-if="checkIfUserHasAnyOfThePermissions(['entry.view_payment', 'entry.pospay_payment'])">
            <a href="/programs/checks" @click="clearFilters">
              Print Checks
            </a>
          </el-menu-item>
          <el-menu-item index="/checks" v-if="checkIfUserHasRequiredPermissions(['entry.view_payment'])">
            <a href="/checks" @click="clearFilters">
              View All Checks
            </a>
          </el-menu-item>
          <el-menu-item index="/reports/checkregister" v-if="checkIfUserHasRequiredPermissions(['auth.view_check_register'])">
            <a href="/reports/checkregister" @click="clearFilters">
              Check Register
            </a>
          </el-menu-item>
          <el-menu-item index="/programs/positivepay" v-if="checkIfUserHasRequiredPermissions(['entry.pospay_payment'])">
            <a href="/programs/positivepay" @click="clearFilters">
              <span>
                Positive Pay
              </span>
            </a>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>

      <!-- Accounts Receivable -->
      <el-submenu index="6" class="nav-side" id="accountsreceivable" v-if="arEnabled && checkIfUserHasAnyOfThePermissions(['entry.view_accountsreceivable', 'entry.add_accountsreceivable'])">
        <template slot="title" v-if="checkIfUserHasRequiredPermissions(['entry.view_accountsreceivable'])">
          <a href="/ars" onclick="javascript:return false;">
            <router-link :to="{ name: 'ARs' }">
              Accounts Receivable
            </router-link>
          </a>
        </template>
        <el-menu-item-group v-if="checkIfUserHasAnyOfThePermissions(['entry.view_accountsreceivable', 'entry.add_accountsreceivable'])">
          <span slot="title">Accounts Receivable</span>
          <el-menu-item index="/ars" v-if="checkIfUserHasRequiredPermissions(['entry.view_accountsreceivable'])">
            <a href="/ars" onclick="javascript:return false;">
              View All A/Rs
            </a>
          </el-menu-item>
          <el-menu-item index="/ars/new" v-if="checkIfUserHasRequiredPermissions(['entry.add_accountsreceivable'])">
            <a href="/ars/new" onclick="javascript:return false;">
              <span>
                Add Bill
              </span>
            </a>
          </el-menu-item>
          <el-submenu index="6-1">
            <span slot="title">Bill Payments</span>
            <el-menu-item index="/bps" v-if="checkIfUserHasRequiredPermissions(['entry.view_accountsreceivable'])">
              <a href="/bps" onclick="javascript:return false;">
                <router-link :to="{ name: 'BPs' }">
                  View All
                </router-link>
              </a>
            </el-menu-item>
            <el-menu-item index="/bps/new" v-if="checkIfUserHasRequiredPermissions(['entry.add_accountsreceivable'])">
              <a href="/bps/new" onclick="javascript:return false;">
                <span>
                  Add Bill Payment
                </span>
              </a>
            </el-menu-item>
          </el-submenu>
          <el-submenu index="6-2">
            <span slot="title">Deposits</span>
            <el-menu-item index="/pps" v-if="checkIfUserHasRequiredPermissions(['entry.view_accountsreceivable'])">
              <a href="/pps" onclick="javascript:return false;">
                <router-link :to="{ name: 'PPs' }">
                  View All
                </router-link>
              </a>
            </el-menu-item>
            <el-menu-item index="/pps/new" v-if="checkIfUserHasRequiredPermissions(['entry.add_accountsreceivable'])">
              <a href="/pps/new" onclick="javascript:return false;">
                <span>
                  Add Deposit
                </span>
              </a>
            </el-menu-item>
          </el-submenu>
          <el-submenu index="6-3" v-if="checkIfUserHasAnyOfThePermissions(['system.view_customer', 'system.add_customer'])">
            <span slot="title">Customers</span>
            <el-menu-item index="/customers" v-if="checkIfUserHasRequiredPermissions(['system.view_customer'])">
              <a href="/customers" onclick="javascript:return false;">
                View All
              </a>
            </el-menu-item>
            <el-menu-item index="" @click="openComponentCreateModal('changeModalVisibility', 'customerVendorForm', 'customer')">
              <span>New Customer</span>
            </el-menu-item>
          </el-submenu>
          <el-menu-item index="/salesreps" v-if="checkIfUserHasRequiredPermissions(['system.view_salesrep'])">
            <a href="/salesreps" onclick="javascript:return false;">
              Sales Reps
            </a>
          </el-menu-item>
          <el-menu-item index="/billabletypes" v-if="checkIfUserHasRequiredPermissions(['system.view_billabletype'])">
            <a href="/billabletypes" onclick="javascript:return false;">
              Billable Types
            </a>
          </el-menu-item>
          <el-menu-item index="/billableitems" v-if="checkIfUserHasRequiredPermissions(['system.view_billableitem'])">
            <a href="/billableitems" onclick="javascript:return false;">
              Billable Items
            </a>
          </el-menu-item>
          <el-menu-item index="/markups" v-if="checkIfUserHasRequiredPermissions(['system.view_markup'])">
            <a href="/markups" onclick="javascript:return false;">
              Markups
            </a>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>

      <!-- Petty Cash -->
      <el-submenu index="7" class="nav-side" id="pettycash" v-if="checkIfUserHasAnyOfThePermissions(['entry.view_pettycash', 'entry.add_pettycash'])">
        <template slot="title" v-if="checkIfUserHasRequiredPermissions(['entry.view_pettycash'])">
          <a href="/pcs" @click="clearFilters">
            <router-link :to="{ name: 'PCs' }">
              Petty Cash
            </router-link>
          </a>
        </template>
        <el-menu-item-group v-if="checkIfUserHasAnyOfThePermissions(['entry.view_pettycash', 'entry.add_pettycash'])">
          <span slot="title">Petty Cash</span>
          <el-menu-item index="/pettycash" v-if="checkIfUserHasRequiredPermissions(['entry.view_pettycash'])">
            <a href="/pettycash" @click="clearFilters">
              View All P/Cs
            </a>
          </el-menu-item>
          <el-menu-item index="/pettycash/new" v-if="checkIfUserHasRequiredPermissions(['entry.add_pettycash'])">
            <a href="/pettycash/new" onclick="javascript:return false;">
              <span>Add PC Envelope</span>
            </a>
          </el-menu-item>
          <el-menu-item index="/programs/posting?type=Pcs" v-if="checkIfUserHasRequiredPermissions(['auth.post_transactions'])">
            <a href="/programs/posting?type=Pcs" onclick="javascript:return false;">
              <span>Audit/Post</span>
            </a>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>

      <!-- Journal Entry -->
      <el-submenu index="8" class="nav-side" id="journalentry" ref="je_submenu" v-if="checkIfUserHasAnyOfThePermissions(['entry.view_journalentry', 'entry.add_journalentry'])">
        <template slot="title" v-if="checkIfUserHasRequiredPermissions(['entry.view_journalentry'])">
          <a href="/jes" @click="clearFilters">
            <router-link :to="{ name: 'JEs' }">
              Journal Entry
            </router-link>
          </a>
        </template>
        <el-menu-item-group>
          <span slot="title">Journal Entry</span>
          <el-menu-item index="/jes" v-if="checkIfUserHasRequiredPermissions(['entry.view_journalentry'])">
            <a href="/jes" @click="clearFilters">
              View All J/Es
            </a>
          </el-menu-item>
          <el-menu-item index="/jes/new" v-if="checkIfUserHasRequiredPermissions(['entry.add_journalentry'])">
            <a href="/jes/new" onclick="javascript:return false;">
              <span>Add Journal Entry</span>
            </a>
          </el-menu-item>
          <el-menu-item index="/programs/posting?type=Jes" v-if="checkIfUserHasRequiredPermissions(['auth.post_transactions'])">
            <a href="/programs/posting?type=Jes" onclick="javascript:return false;">
              <span>Audit/Post</span>
            </a>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>

      <!-- Payroll -->
      <el-submenu index="9" class="nav-side" id="payrollentry" ref="je_submenu" v-if="checkIfUserHasAnyOfThePermissions(['entry.view_payrollentry', 'entry.add_payrollentry'])">
        <template slot="title" v-if="checkIfUserHasRequiredPermissions(['entry.view_payrollentry'])">
          <a href="/prs" @click="clearFilters">
            <router-link :to="{ name: 'PRs' }">
              Payroll
            </router-link>
          </a>
        </template>
        <el-menu-item-group>
          <span slot="title">Payroll</span>
          <el-menu-item index="/prs" v-if="checkIfUserHasRequiredPermissions(['entry.view_payrollentry'])">
            <a href="/prs" @click="clearFilters">
              View All Payroll Entries
            </a>
          </el-menu-item>
          <el-menu-item index="/prs/new" v-if="checkIfUserHasRequiredPermissions(['entry.add_payrollentry'])">
            <a href="/prs/new" onclick="javascript:return false;">
              <span>Add Payroll Entry</span>
            </a>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>

      <!-- Purchase Orders -->
      <el-submenu index="10" class="nav-side" id="purchaseorder" v-if="checkIfUserHasAnyOfThePermissions(['entry.view_purchaseorder', 'entry.add_purchaseorder'])">
        <template slot="title" v-if="checkIfUserHasRequiredPermissions(['entry.view_purchaseorder'])">
          <a href="/pos" @click="clearFilters">
            <router-link :to="{ name: 'POs' }">
              Purchase Orders
            </router-link>
          </a>
        </template>
        <el-menu-item-group>
          <span slot="title">Purchase Orders</span>
          <el-menu-item index="/pos" v-if="checkIfUserHasRequiredPermissions(['entry.view_purchaseorder'])">
            <a href="/pos" @click="clearFilters">
              View All P/Os
            </a>
          </el-menu-item>
          <el-menu-item index="/pos/new" v-if="checkIfUserHasRequiredPermissions(['entry.add_purchaseorder'])">
            <a href="/pos/new" onclick="javascript:return false;">
              <span>Add Purchase Order</span>
            </a>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>

      <!-- Vendors -->
      <el-submenu index="11" class="nav-side" id="vendors" v-if="checkIfUserHasAnyOfThePermissions(['system.view_vendor', 'system.add_vendor', 'auth.view_vendor_history_report', 'auth.view_vendor_list_report'])">
        <template slot="title" v-if="checkIfUserHasAnyOfThePermissions(['system.view_vendor', 'system.add_vendor', 'auth.view_vendor_history_report', 'auth.view_vendor_list_report'])">
          <a href="/vendors" onclick="javascript:return false;">
            <router-link :to="{ name: 'Vendors' }">
              Vendors
            </router-link>
          </a>
        </template>
        <el-menu-item-group>
          <span slot="title">Vendors</span>
          <el-menu-item index="/vendors" v-if="checkIfUserHasRequiredPermissions(['system.view_vendor'])">
            <a href="/vendors" onclick="javascript:return false;">
              View All
            </a>
          </el-menu-item>
          <el-menu-item
            index=""
            v-if="checkIfUserHasRequiredPermissions(['system.add_vendor'])"
            @click="openComponentCreateModal('changeModalVisibility', 'customerVendorForm', 'vendor')">
            <span>New Vendor</span>
          </el-menu-item>
          <el-menu-item index="/reports/vendorreport" v-if="checkIfUserHasRequiredPermissions(['auth.view_vendor_history_report'])">
            Vendor History Report
          </el-menu-item>
          <el-menu-item index="/reports/vendorlist" v-if="checkIfUserHasRequiredPermissions(['auth.view_vendor_list_report'])">
            Vendor List
          </el-menu-item>
          <el-menu-item index="/programs/vendorimport">
            Vendor Import
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>

      <!-- Customers -->
      <el-submenu index="12" class="nav-side" id="customers" v-if="arEnabled && checkIfUserHasAnyOfThePermissions(['system.view_customer', 'system.add_customer'])">
        <template slot="title" v-if="checkIfUserHasRequiredPermissions(['system.view_customer'])">
          <a href="/customers" onclick="javascript:return false;">
            <router-link :to="{ name: 'Customers' }">
              Customers
            </router-link>
          </a>
        </template>
        <el-menu-item-group>
          <span slot="title">Customers</span>
          <el-menu-item index="/customers" v-if="checkIfUserHasRequiredPermissions(['system.view_customer'])">
            <a href="/customers" onclick="javascript:return false;">
              View All
            </a>
          </el-menu-item>
          <el-menu-item index="" @click="openComponentCreateModal('changeModalVisibility', 'customerVendorForm', 'customer')">
            <span>New Customer</span>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>

      <!-- Programs -->
      <el-submenu index="13" class="nav-side" id="programs" v-if="checkIfUserHasAnyOfThePermissions(programsPermissions)">
        <template slot="title">
          Programs
        </template>
        <el-menu-item-group>
          <span slot="title">Programs</span>
          <el-menu-item index="/programs/posting" v-if="checkIfUserHasRequiredPermissions(['auth.post_transactions'])">
            <a href="/programs/posting" onclick="javascript:return false;">
              Transaction Posting
            </a>
          </el-menu-item>
          <el-menu-item index="/programs/bankrecs" v-if="checkIfUserHasRequiredPermissions(['programs.view_bankrecon'])">
            <a href="/programs/bankrecs" onclick="javascript:return false;">
              <router-link :to="{ name: 'BankRecs' }">
                Bank Reconciliation
              </router-link>
            </a>
          </el-menu-item>
          <el-submenu index="13-3" v-if="checkIfUserHasAnyOfThePermissions(['entry.view_period', 'entry.close_period'])">
            <span slot="title" v-if="checkIfUserHasRequiredPermissions(['entry.view_period'])">
              <a href="/programs/periodmanager" onclick="javascript:return false;">
                <span>Period Manager</span>
              </a>
            </span>
            <el-menu-item index="/programs/periodmanager" v-if="checkIfUserHasRequiredPermissions(['entry.view_period'])">
              <a href="/programs/periodmanager" onclick="javascript:return false;">
                View all periods
              </a>
            </el-menu-item>
            <el-menu-item index="/programs/periodmanager?closeCurrent=true" v-if="checkIfUserHasRequiredPermissions(['entry.close_period'])">
              <i class="el-icon-circle-close"></i>
              <a href="/programs/periodmanager" onclick="javascript:return false;">
                <span>Close Current Period</span>
              </a>
            </el-menu-item>
            <!-- Update previous variance and using li to keep nav menu open -->
            <li class="el-menu-item" style="padding-left: 20px" @click="lockVarianceThisPeriod()">
              <i class="el-icon-loading" v-if="upadating"></i>
              <i class="el-icon-setting" v-else></i>
              <span>Lock Variance This Period</span>
            </li>
          </el-submenu>
        </el-menu-item-group>
      </el-submenu>

      <!-- Reports -->
      <el-submenu index="14" v-if="checkIfUserHasAnyOfThePermissions(reportPermissions)" class="nav-side" id="reports">
        <template slot="title">
          Reports
        </template>
        <el-menu-item-group>
          <template slot="title">
            Reports
          </template>
          <el-menu-item v-if="checkIfUserHasRequiredPermissions(['auth.view_cost_report'])" index="/programs/costreporter">
              <a href="/programs/costreporter" onclick="javascript:return false;">
              Cost Reporting
              </a>
          </el-menu-item>
          <el-menu-item v-if="checkIfUserHasRequiredPermissions(['auth.view_trail_balance'])" index="/reports/trialbalance">
            Trial Balance
          </el-menu-item>
          <el-menu-item v-if="checkIfUserHasRequiredPermissions(['auth.view_gl_bible_report'])" index="/reports/glreport">
            GL Bible Report
          </el-menu-item>
          <el-menu-item v-if="checkIfUserHasRequiredPermissions(['auth.view_gl_bible_report'])" index="/reports/openitemsbyaccount">
            Open Items By Account Report
          </el-menu-item>
          <el-menu-item v-if="checkIfUserHasRequiredPermissions(['auth.view_vendor_history_report'])" index="/reports/openitemsbyvendor">
            Open Items By Vendor Report
          </el-menu-item>
          <el-menu-item v-if="checkIfUserHasRequiredPermissions(['propay.view_employee_earning_report'])" index="/reports/employeereport">
            Employee Earnings Report
          </el-menu-item>
          <el-menu-item v-if="checkIfUserHasRequiredPermissions(['auth.view_purchase_orders_report'])" index="/reports/poreport">
            Purchase Order Reports
          </el-menu-item>
          <el-menu-item v-if="checkIfUserHasRequiredPermissions(['auth.view_ap_aging_report'])" index="/reports/apagingreport">
            AP Aging Report
          </el-menu-item>
          <el-menu-item v-if="checkIfUserHasRequiredPermissions(['auth.view_check_register'])" index="/reports/checkregister">
            Check Register
          </el-menu-item>
          <el-menu-item v-if="checkIfUserHasRequiredPermissions(['auth.view_vendor_history_report'])" index="/reports/vendorreport">
            Vendor History Report
          </el-menu-item>
          <el-menu-item v-if="checkIfUserHasRequiredPermissions(['auth.view_vendor_list_report'])" index="/reports/vendorlist">
            Vendor List
          </el-menu-item>
          <el-menu-item v-if="checkIfUserHasRequiredPermissions(['auth.view_chart_of_accounts_report'])" index="/reports/accountlist">
            Chart of Accounts List
          </el-menu-item>
          <el-menu-item v-if="checkIfUserHasRequiredPermissions(['auth.view_asset_reporting_report'])" index="/reports/assetreport">
            Asset Report
          </el-menu-item>
          <el-menu-item v-if="checkIfUserHasRequiredPermissions(['auth.view_1099_tax_reporting'])" index="/reports/taxreport2025">
            1099 Tax Reporting
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>

      <!-- Setup -->
      <el-submenu index="15" class="nav-side" id="setup">
        <template slot="title">
          Setup
        </template>
        <el-menu-item-group>
          <span slot="title">Setup</span>
          <el-menu-item index="/accounts" v-if="checkIfUserHasRequiredPermissions(['system.view_account'])">
            <a href="/accounts" onclick="javascript:return false;">
              Accounts (COA)
            </a>
          </el-menu-item>
          <el-menu-item index="/accountgroup" v-if="checkIfUserHasRequiredPermissions(['system.view_accountgroup'])">
            <a href="/accountgroup" onclick="javascript:return false;">
              Account Group
            </a>
          </el-menu-item>
          <el-menu-item index="/banks" v-if="checkIfUserHasRequiredPermissions(['system.view_bank'])">
            <a href="/banks" onclick="javascript:return false;">
              Banks
            </a>
          </el-menu-item>
          <el-menu-item index="/companies" v-if="checkIfUserHasRequiredPermissions(['system.view_company'])">
            <a href="/companies" onclick="javascript:return false;">
              Companies
            </a>
          </el-menu-item>
          <el-menu-item index="/productions" v-if="checkIfUserHasRequiredPermissions(['system.view_production'])">
            <a href="/productions" onclick="javascript:return false;">
              Productions
            </a>
          </el-menu-item>
          
          <el-submenu index="15-1" v-if="checkIfUserHasAnyOfThePermissions(codesPermissions)">
            <span slot="title">Codes</span>
            <el-menu-item index="/series" v-if="checkIfUserHasRequiredPermissions(['system.view_series'])">
              <a href="/series" onclick="javascript:return false;">
                Series
              </a>
            </el-menu-item>
            <el-menu-item index="/locations" v-if="checkIfUserHasRequiredPermissions(['system.view_location'])">
              <a href="/locations" onclick="javascript:return false;">
                Locations
              </a>
            </el-menu-item>
            <el-menu-item index="/sets" v-if="checkIfUserHasRequiredPermissions(['system.view_set'])">
              <a href="/sets" onclick="javascript:return false;">
                Sets
              </a>
            </el-menu-item>
            <el-menu-item index="/freefields" v-if="checkIfUserHasRequiredPermissions(['system.view_freefield'])">
              <a href="/freefields" onclick="javascript:return false;">
                Free Fields
              </a>
            </el-menu-item>
            <el-menu-item index="/taxcodes" v-if="checkIfUserHasRequiredPermissions(['system.view_countrytaxcode'])">
              <a href="/taxcodes" onclick="javascript:return false;">
                Tax Codes
              </a>
            </el-menu-item>
            <el-menu-item index="/insurancecodes" v-if="checkIfUserHasRequiredPermissions(['system.view_insurance'])">
              <a href="/insurances" onclick="javascript:return false;">
                Insurance Codes
              </a>
            </el-menu-item>
          </el-submenu>
          <el-menu-item index="/currencies" v-if="checkIfUserHasRequiredPermissions(['system.view_currency'])">
            <a href="/currencies" onclick="javascript:return false;">
              Currencies
            </a>
          </el-menu-item>
          <el-menu-item index="/departments" v-if="checkIfUserHasRequiredPermissions(['system.view_departments'])">
            <a href="/departments" onclick="javascript:return false;">
              Departments
            </a>
          </el-menu-item>
          <el-menu-item index="/users" v-if="checkIfUserHasRequiredPermissions(['auth.view_user'])">
            <a href="/users" onclick="javascript:return false;">
              Users
            </a>
          </el-menu-item>
          <el-menu-item index="/programs/signaturecapture">
            <a href="/programs/signaturecapture" onclick="javascript:return false;">
              User Settings
            </a>
          </el-menu-item>
          <el-menu-item index="/roles" v-if="checkIfUserHasRequiredPermissions(['system.view_roles'])">
            <a href="/roles" onclick="javascript:return false;">
              Roles
            </a>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>

      <!-- System -->
      <el-submenu index="16" class="nav-side" id="system" v-if="checkIfUserHasAnyOfThePermissions(systemPermissions)">
        <template slot="title">
          System
        </template>
        <el-menu-item-group>
          <span slot="title">System</span>
          <el-menu-item index="/batches" v-if="checkIfUserHasRequiredPermissions(['entry.view_batch'])">
            <a href="/batches" onclick="javascript:return false;">
              Batches
            </a>
          </el-menu-item>
          <el-menu-item index="/budgets" v-if="checkIfUserHasRequiredPermissions(['system.view_budget'])">
            <a href="/budgets" onclick="javascript:return false;">
              Budgets
            </a>
          </el-menu-item>
          <el-menu-item index="/budgetImport" v-if="checkIfUserHasRequiredPermissions(['system.view_budget'])">
            <a href="/budgetImport" onclick="javascript:return false;">
              Budget Import
            </a>
          </el-menu-item>
          <el-menu-item index="/states" v-if="checkIfUserHasRequiredPermissions(['system.view_state'])">
            <a href="/states" onclick="javascript:return false;">
              States
            </a>
          </el-menu-item>
          <el-menu-item index="/countries" v-if="checkIfUserHasRequiredPermissions(['system.view_country'])">
            <a href="/countries" onclick="javascript:return false;">
              Countries
            </a>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    data () {
      return {
        isCollapse: true,
        quickAddPermissions: [
          'entry.add_purchaseorder',
          'entry.add_accountspayable',
          'entry.add_pettycash',
          'add_journalentry',
          'system.add_vendor',
          'entry.view_payment'
        ],
        programsPermissions: [
          'auth.post_transactions',
          'entry.view_payment',
          'programs.view_bankrecon',
          'entry.view_period',
          'entry.close_period'
        ],
        codesPermissions: [
          'system.view_series',
          'system.view_location',
          'system.view_set',
          'system.view_freefield',
          'system.view_countrytaxcode',
          'system.view_insurance'
        ],
        systemPermissions: [
          'entry.view_batch',
          'system.view_budget',
          'system.view_state',
          'system.view_country'
        ],
        reportPermissions: [
          'auth.view_cost_report',
          'auth.view_trail_balance',
          'auth.view_gl_bible_report',
          'auth.view_purchase_orders_report',
          'auth.view_ap_aging_report',
          'auth.view_check_register',
          'auth.view_vendor_history_report',
          'auth.view_vendor_list_report',
          'auth.view_chart_of_accounts_report',
          'propay.view_employee_earning_report',
          'auth.view_asset_reporting_report',
          'auth.view_1099_tax_reporting',
          'auth.view_audit_report_by_transaction',
          'auth.view_audit_report_by_account',
          'auth.view_posting_report_by_transaction',
          'auth.view_positing_report_by_account'
        ],
        proscanPermissions: [
          'entry.view_accountspayable',
          'entry.view_purchaseorder',
          'system.view_vendor'
        ],
        reportNotif: '',
        upadating: false
      }
    },
    methods: {
      /**
       * Handles opening an app-wide create modal, such as new customer, vendor or new account
       * @param modalOpenAction
       * @param entityType
       * @param type
       */
      openComponentCreateModal (modalOpenAction, entityType, type = null) {
        if (type) {
          this.$store.dispatch(modalOpenAction, { entityType, visible: true, type })
        } else {
          this.$store.dispatch(modalOpenAction, { entityType, visible: true })
        }
      },
      async clearFilters () {
        sessionStorage.removeItem('gridFilterModel:APs')
        sessionStorage.removeItem('gridFilterModel:PCs')
        sessionStorage.removeItem('gridFilterModel:JEs')
        sessionStorage.removeItem('gridFilterModel:PRs')
        sessionStorage.removeItem('gridFilterModel:POs')
        await this.$store.dispatch('clearSetApFilterInfo')
        await this.$store.dispatch('clearSetPcFilterInfo')
        await this.$store.dispatch('clearSetPoFilterInfo')
        await this.$store.dispatch('clearSetJeFilterInfo')
        await this.$store.dispatch('clearSetPrFilterInfo')
        await this.$store.dispatch('resetActiveTab')

        sessionStorage.removeItem('gridFilterModel:Checks')
        sessionStorage.removeItem('gridFilterModel:Payments')
        sessionStorage.removeItem('gridFilterModel:PaymentProcessing')
        sessionStorage.removeItem('gridFilterModel:CheckProcessing')
        await this.$store.dispatch('clearFilters')
        return
      },
      async handleSearch () {
        if (this.isGlobalSearchLoading) return
        let searchText = this.searchText.trim()
        this.searchText = ''
        if (!searchText) return
        if (this.$route.name === 'SearchResults' && this.$route.query && this.$route.query.searchKey === searchText) return
        await this.$store.dispatch('clearSearchResultsState', [])
        await this.$store.dispatch('resetSearchResultsMeta')
        if (!this.$route.query || !this.$route.query.searchKey || this.$route.query.searchKey !== searchText) await this.$router.push({path: `/searchresults?searchKey=${searchText}`})
      },
      clearKeyword () {
        this.searchText = ''
      },
      async lockVarianceThisPeriod () {
        this.upadating = true
        this.reportNotif = this.$message({
          message: 'Updating Previous variance..',
          type: 'warning',
          showClose: true,
          duration: 0
        })
        this.$store.dispatch('copyVariance')
          .then(r => {
            this.reportNotif.close()
            this.reportNotif = this.$message({
              message: r.message,
              type: 'success',
              showClose: true,
              duration: 0
            })
            this.upadating = false
          })
          .catch(e => {
            console.log(e)
            this.upadating = false
          })
        return
      }
    },
    computed: {
      ...mapGetters({
        isGlobalSearchLoading: 'getReceivingDataStatus',
        instance: 'getActiveInstance',
        checkIfUserHasRequiredPermissions: 'checkIfUserHasRequiredPermissions',
        checkIfUserHasAnyOfThePermissions: 'checkIfUserHasAnyOfThePermissions'
      }),
      /**
       * Checks the instance settings and determines whether AR module should be shown
       * @return {boolean}
       */
      arEnabled () {
        return !!this.$store.getters.getUiSettings['AR_ENABLED']
      },
      payrollEnabled () {
        return !!this.$store.getters.getUiSettings['PAYROLL_ENABLED']
      },
      /**
       * Checks the instance settings and determines whether beta Cost Reporter should be shown
       * @return {boolean}
       */
      costReporterBetaEnabled () {
        return !!this.$store.getters.getUiSettings['COST_REPORTER_BETA_ENABLED']
      },
      achEnabled () {
        return !!this.$store.getters.getUiSettings['ACH_ENABLED']
      }
    }
  }
</script>

<style scoped>
  .el-menu-item.is-active, .el-menu a:visited, span a:visited {
    text-decoration: none !important;
    color: #bfcbd9 !important;
  }
  .menuItem {
    padding: 0;
  }
  .menuItemRouterLink {
    padding-left: 10px;
    display: block;
  }
  .newTag {
    background: rgb(227, 244, 247);
    color: rgb(4, 112, 157) !important;
    font-size: 10px;
    font-weight: 700;
    line-height: 16px;
    border-radius: 2px;
    padding: 3px 6px;
    letter-spacing: 0.5px;
    float: right;
    margin-top: 7px;
  }
</style>

<style>
  #nav-col {
    width: 165px;
  }
  .nav-side {
    text-align: left;
  }
  .nav-side .el-menu-item-group__title {
    padding: 20px;
    font-weight: bold;
    font-size: 14px;
    color: #ffffff;
    background: transparent;
  }
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
  }
  .el-submenu__title * {
    vertical-align: middle;
    color: #ccc !important;
}
  ul.el-menu {
    background: transparent;
  }
  .el-submenu__title {
      height: 35px !important;
      line-height: 35px !important;
  }
  .el-submenu__title:hover {
    background: #ccc;
  }
  .el-submenu .el-menu-item{
      height: 35px !important;
      line-height: 35px !important;
  }
</style>



// WEBPACK FOOTER //
// src/layouts/NavSide.vue